import Quill from 'quill';

const InlineEmbed = Quill.import('blots/inline');

class FindReplaceBlot extends InlineEmbed {
  static create() {
    const node = super.create();
    node.contentEditable = 'true';
    return node;
  }

  optimize() {}
}

FindReplaceBlot.blotName = 'FindReplaceEmbed';
FindReplaceBlot.className = 'ql-find-replace-embed';
FindReplaceBlot.tagName = 'span';

export default FindReplaceBlot;
